import { Component, Input } from '@angular/core';
import { ModeView } from '../../../shared/ontology/model/mode-view.enum';
import { MetadataDetails } from '../../../shared/ontology/model/metadata-details';
import { TermSummary } from '../../../shared/ontology/model/term-summary';

@Component({
    selector: 'jhi-metadata',
    templateUrl: './metadata.component.html'
})
export class MetadataComponent {
    protected readonly ModeView = ModeView;

    @Input() modeView: ModeView;
    @Input() metadata: MetadataDetails;
    @Input() extendedUsage = false;

    showMetadata = false;

    usageFields = [
        { field: 'datasets', label: 'ontology-manager.metadata.datasets' },
        { field: 'observations', label: 'ontology-manager.metadata.observations' },
        { field: 'germplasm', label: 'ontology-manager.metadata.germplasm' },
        { field: 'breedingMethods', label: 'ontology-manager.metadata.breeding.methods' },
        { field: 'lists', label: 'ontology-manager.metadata.lists' },
        { field: 'lots', label: 'ontology-manager.metadata.lots' },
    ];


    toggle(): void {
        this.showMetadata = !this.showMetadata;
    }

    formatListForDisplay(terms: TermSummary[]): string {
        if (terms) {
            var names = terms.map(function(item) {
                return item.name;
            });
            return names.join(', ');
        }
        return '';
    }
}
